import type { BoxSessionDetailsEntity } from "@/modules/boxSlotSession/entities/boxSessionEntity"
import { create } from "@/modules/core/store"
import type { ProgramInfiniteSessionEntity } from "@/modules/sessions/entities/programInfiniteSessionEntity"
import type { ProgramOnOffSessionEntity } from "@/modules/sessions/entities/programOnOffSessionEntity"

type SessionCopyActions = {
  setSessionCopy: (
    sessionCopy: ProgramInfiniteSessionEntity | ProgramOnOffSessionEntity | BoxSessionDetailsEntity,
  ) => void
}

type SessionCopyState = {
  sessionCopy: ProgramInfiniteSessionEntity | ProgramOnOffSessionEntity | BoxSessionDetailsEntity | null
  actions: SessionCopyActions
}

const useSessionCopyStore = create<SessionCopyState>()((set) => ({
  sessionCopy: null,
  actions: {
    setSessionCopy: (
      sessionCopy: ProgramInfiniteSessionEntity | ProgramOnOffSessionEntity | BoxSessionDetailsEntity,
    ) => {
      set({ sessionCopy })
    },
  },
}))

export const useSessionCopy = () => useSessionCopyStore((state) => state.sessionCopy)
export const useSessionCopyActions = () => useSessionCopyStore((state) => state.actions)
